import { SecureStorage } from '@aparajita/capacitor-secure-storage';

/**
 * Keychain (iOS) / Keystore-backed (Android) key-value storage for native session tokens.
 * Web never stores tokens: its session lives in httpOnly cookies set by khova-api.
 */
export const readSecureItem = (key: string): Promise<string | null> => SecureStorage.getItem(key);

export const writeSecureItem = (key: string, value: string): Promise<void> => SecureStorage.setItem(key, value);

export const removeSecureItem = (key: string): Promise<void> => SecureStorage.removeItem(key);
